<p-dialog
  [maximizable]="true"
  class="filters-modal add-cashout"
  header="Nuevo cashout"
  [modal]="true"
  [(visible)]="ctx.showNewTransaction"
  [style]="{ width: '1100px' }"
  *ngIf="ctx.showNewTransaction && ctx.currency == 'COP'"
  (visibleChange)="ctx.closeAddModal()"
>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType !== 'csv'">
    <div class="form-heading">
      <div class="form-title">Ingresa los siguientes campos de tu cashout</div>
      <p-button
        *ngIf="ctx.canShowCsvUpload()"
        label="Subida en lotes (.CSV)"
        severity="secondary"
        [outlined]="true"
        (click)="ctx.showCsvUpload()"
      />
    </div>

    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="ctx.newTransactionForm">
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item">
              <label for="status">ID de la transacción (Opcional)</label>
              <input
                type="number"
                placeholder="Ingresa el ID de la transacción"
                formControlName="transaction_id"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item" *ngIf="ctx.auth.hasRole(ctx.roles.Admin)">
              <label for="client_id">Cliente asignado</label>
              <p-dropdown
                placeholder="Elige un cliente"
                formControlName="client_id"
                [options]="ctx.userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
                appendTo="body"
              />
            </div>

            <div class="form-item">
              <label for="status">Tipo de transacción</label>
              <div class="account-type-picker">
                <div
                  *ngFor="let type of ctx.transactionTypes"
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.transaction_type.value ===
                    type.id
                  "
                  (click)="ctx.setTransactionType(type.id)"
                >
                  {{ type.id }}
                </div>
              </div>
            </div>
            <div
              class="form-item"
              *ngIf="isCopMinteoBankSelected() && !isCopBitsoBankSelected()"
            >
              <label for="cop_minteo_channel">Canal de desembolso</label>
              <p-dropdown
                id="cop_minteo_channel"
                formControlName="minteo_channel"
                [options]="minteoCopChannelOptions"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                (onChange)="onMinteoChannelChange()"
                styleClass="w-full"
              />
              <small class="p-text-secondary"
                >SAVE/TURBO: banco y cuenta. BREB: llave BreB.
                <a
                  href="https://docs.minteo.com/payouts/create-payout"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Docs</a
                >.</small
              >
            </div>
            <div class="form-item" *ngIf="isCopBitsoBankSelected()">
              <label for="cop_payout_provider">Proveedor de payout</label>
              <p class="p-text-secondary" style="margin: 0">
                Bitso Colombia (ACH). Indica el banco y la cuenta del
                beneficiario.
              </p>
            </div>
            <div
              class="form-item"
              *ngIf="
                ctx.isBankTransferSelected &&
                (!isCopMinteoBankSelected() ||
                  isCopBitsoBankSelected() ||
                  ctx.newTransactionForm.get('minteo_channel')?.value !==
                    'BREB')
              "
            >
              <label for="status">Selecciona el tipo de cuenta</label>
              <div class="account-type-picker">
                <div
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.account_type.value ===
                    'Cuenta Corriente'
                  "
                  (click)="ctx.setAccountType('Cuenta Corriente')"
                >
                  Cuenta Corriente
                </div>
                <div
                  class="accu-type"
                  [class.selected]="
                    ctx.newTransactionForm.controls.account_type.value ===
                    'Cuenta de Ahorros'
                  "
                  (click)="ctx.setAccountType('Cuenta de Ahorros')"
                >
                  Cuenta de Ahorros
                </div>
              </div>
            </div>
          </div>
          <div class="filter-column">
            <div class="form-item">
              <label for="status">Nombres</label>
              <input
                type="text"
                placeholder="Ingresa los nombres"
                formControlName="firstname"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="status">Apellidos</label>
              <input
                type="text"
                placeholder="Ingresa los apellidos del recipiente"
                formControlName="lastname"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="cop_document_type_number"
                >Documento de identidad <span class="required">*</span></label
              >
              <input
                id="cop_document_type_number"
                type="text"
                placeholder="ej. CC-123456789"
                formControlName="document_type_number"
                pInputText
                class="id-input-filter"
              />
              <small class="p-text-secondary"
                >Formato: tipo de documento, guion, número (ej. CC-123456789,
                CE-12345678).</small
              >
            </div>
          </div>
          <div class="filter-column">
            <div
              class="form-item"
              *ngIf="
                !isCopMinteoBankSelected() ||
                isCopBitsoBankSelected() ||
                ctx.newTransactionForm.get('minteo_channel')?.value !== 'BREB'
              "
            >
              <label for="status">{{
                isCopBitsoBankSelected() ? "Proveedor de payout" : "Banco"
              }}</label>
              <p-dropdown
                [placeholder]="
                  isCopBitsoBankSelected()
                    ? 'Elige Bitso COP'
                    : 'Elige el banco'
                "
                formControlName="company_id"
                [options]="ctx.getBanks()"
                optionLabel="shortname"
                [filter]="true"
                filterBy="shortname"
                (onChange)="pickBank($event)"
                appendTo="body"
              />
            </div>

            <div class="form-item" *ngIf="isCopBitsoBankSelected()">
              <label for="cop_beneficiary_bank"
                >Banco beneficiario (Colombia)
                <span class="required">*</span></label
              >
              <p-dropdown
                id="cop_beneficiary_bank"
                placeholder="Elige el banco del beneficiario"
                formControlName="cop_beneficiary_bank"
                [options]="copBeneficiaryBankOptions()"
                optionLabel="shortname"
                [filter]="true"
                filterBy="shortname"
                appendTo="body"
              />
              <small class="p-text-secondary"
                >Código ACH usado por Bitso (ej. Bancolombia,
                Davivienda).</small
              >
            </div>

            <ng-container *ngIf="isNotbankBankSelected()" formGroupName="notbank_bank">
              <div class="form-item">
                <label>Banco Notbank <span class="required">*</span></label>
                <p-dropdown
                  formControlName="bank"
                  [options]="notbankBanks"
                  optionLabel="label"
                  [filter]="true"
                  filterBy="label,name"
                  [loading]="loadingNotbankBanks"
                  placeholder="Selecciona banco"
                  appendTo="body"
                  styleClass="w-full"
                />
              </div>
              <div class="form-item">
                <label>Tipo cuenta Notbank <span class="required">*</span></label>
                <p-dropdown
                  formControlName="kind"
                  [options]="notbankKindOptions"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="onNotbankKindChange()"
                  appendTo="body"
                  styleClass="w-full"
                />
              </div>
              <div class="form-item">
                <label>Número de cuenta Notbank <span class="required">*</span></label>
                <input pInputText formControlName="number" class="id-input-filter" />
              </div>
            </ng-container>

            <div
              class="form-item"
              *ngIf="
                isCopMinteoBankSelected() &&
                !isCopBitsoBankSelected() &&
                ctx.newTransactionForm.get('minteo_channel')?.value === 'BREB'
              "
            >
              <label for="cop_breb_key_type"
                >Tipo de llave BreB <span class="required">*</span></label
              >
              <p-dropdown
                id="cop_breb_key_type"
                formControlName="breb_key_type"
                [options]="brebKeyTypeOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Ej. PHONE"
                appendTo="body"
                (onChange)="onMinteoChannelChange()"
                styleClass="w-full"
              />
            </div>

            <div
              class="form-item"
              *ngIf="
                isCopMinteoBankSelected() &&
                ctx.newTransactionForm.get('minteo_channel')?.value === 'BREB'
              "
            >
              <label for="cop_breb_key_value"
                >Valor de la llave <span class="required">*</span></label
              >
              <input
                id="cop_breb_key_value"
                type="text"
                pInputText
                formControlName="breb_key_value"
                class="id-input-filter"
                [placeholder]="
                  ctx.newTransactionForm.get('breb_key_type')?.value === 'PHONE'
                    ? '10 dígitos, ej. 3107654321'
                    : ctx.newTransactionForm.get('breb_key_type')?.value ===
                        'ALPHANUMERIC'
                      ? 'Ej. @usuario123'
                      : ctx.newTransactionForm.get('breb_key_type')?.value ===
                          'EMAIL'
                        ? 'correo@dominio.com'
                        : 'Documento o identificador'
                "
                autocomplete="off"
              />
            </div>

            <div
              class="form-item"
              *ngIf="
                !isNotbankBankSelected() &&
                (!isCopMinteoBankSelected() ||
                  isCopBitsoBankSelected() ||
                  ctx.newTransactionForm.get('minteo_channel')?.value !== 'BREB')
              "
            >
              <label for="status">Número de cuenta</label>
              <input
                type="tel"
                placeholder="Ingresa el número de cuenta"
                formControlName="account_number"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div class="form-item">
              <label for="status">Monto</label>
              <input
                type="number"
                placeholder="Ingresa el monto del cashout"
                formControlName="amount"
                pInputText
                class="id-input-filter"
              />
            </div>

            <div
              class="form-item"
              *ngIf="isCopMinteoBankSelected() && !isCopBitsoBankSelected()"
            >
              <label for="add_cop_minteo_wallet">Wallet de Origen</label>
              <p-dropdown
                id="add_cop_minteo_wallet"
                formControlName="minteo_origin_wallet_id"
                [options]="minteoOriginWallets"
                optionLabel="label"
                optionValue="id"
                placeholder="Selecciona wallet de origen"
                [showClear]="true"
                [filter]="true"
                filterBy="label,id"
                appendTo="body"
              />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="ctx.exitNewTransaction()"
      />
      <p-button
        label="Guardar cashout"
        [disabled]="
          isCopDocumentMissing() ||
          ctx.newTransactionForm.invalid ||
          ctx.addingTransaction
        "
        [loading]="ctx.addingTransaction"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>
  <div class="new-transaction-form" *ngIf="ctx.newTransactionType === 'csv'">
    <div class="form-heading">
      <div class="form-title">
        Selecciona el archivo .csv que contiene los cashouts a agregar
      </div>
      <a
        class="csv-template-link"
        [href]="'/csv/cashout/' + ctx.currency + '.csv'"
        [download]="ctx.currency + '.csv'"
      >
        Descargar plantilla CSV
      </a>
    </div>
    <div class="picker">
      <input
        id="cashout_csv_file_cop"
        class="csv-file-input"
        type="file"
        accept=".csv"
        (change)="ctx.onFileSelected($event)"
      />
      <label class="csv-upload-box" for="cashout_csv_file_cop">
        <span class="csv-upload-icon">
          <i class="pi pi-upload"></i>
        </span>
        <span class="csv-upload-copy">
          <span class="csv-upload-title">
            {{ ctx.selectedFile?.name || "Selecciona tu archivo CSV" }}
          </span>
          <span class="csv-upload-subtitle">
            {{
              ctx.selectedFile
                ? "Archivo listo para subir"
                : "Solo archivos .csv"
            }}
          </span>
        </span>
      </label>
      <div class="picker-actions">
        <p-button
          label="Volver al formulario"
          severity="secondary"
          [outlined]="true"
          (click)="ctx.showCashoutForm()"
        />

        <p-button
          label="Subir archivo"
          [disabled]="!ctx.selectedFile"
          [loading]="ctx.uploadingCSV"
          severity="secondary"
          (click)="ctx.uploadFile()"
        />
      </div>
    </div>
  </div>
</p-dialog>
